import { TRANSFER_ORDER_UNSHIPPED_OPEN_STATUS_IDS } from './transfer-order-unshipped-open-status-ids.js';
/** Issued or Pick: the statuses a transfer can be picked and cancelled from; shipping needs Pick. */
export function isTransferOrderPickable(statusId) {
    return statusId != null && TRANSFER_ORDER_UNSHIPPED_OPEN_STATUS_IDS.includes(statusId);
}
//# sourceMappingURL=is-transfer-order-pickable.js.map